import { useMemo, useState } from "react";
import { FaClock } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import {
  InstallationPickerOption,
  InstallationPickerRow,
  InstallationPickerSheet,
} from "../installation/InstallationPickerSheet";
import { buildRemovalTimeOptions } from "./notificationRemovalTimeUtils";

const NotificationRemovalTimePicker = ({
  value,
  onChange,
  disabled,
  embedded = false,
}) => {
  const { t } = useTranslation();
  const [sheetOpen, setSheetOpen] = useState(false);
  const placeholder = t("mobile_notifications_removal_time_placeholder");

  const options = useMemo(() => buildRemovalTimeOptions(), []);

  const displayValue = value?.trim() || "";

  const row = (
    <InstallationPickerRow
      icon={FaClock}
      title={placeholder}
      subtitle={displayValue}
      placeholder={placeholder}
      onClick={() => setSheetOpen(true)}
      disabled={disabled}
    />
  );

  return (
    <>
      {embedded ? (
        row
      ) : (
        <div className="installation-settings-card notification-removal-time-picker-card">
          {row}
        </div>
      )}

      <InstallationPickerSheet
        open={sheetOpen}
        title={t("mobile_notifications_removal_time_sheet_title")}
        onDismiss={() => setSheetOpen(false)}
      >
        {options.map((option) => (
          <InstallationPickerOption
            key={option.value}
            label={option.label}
            selected={displayValue === option.value}
            onSelect={() => {
              onChange(option.value);
              setSheetOpen(false);
            }}
          />
        ))}
      </InstallationPickerSheet>
    </>
  );
};

export default NotificationRemovalTimePicker;
